/// <reference path='../../include.ts' />

namespace gpx_visualizer_phase2 {

	import IFileHandler = alm.io.IFileHandler;
	import CompleteFunction = alm.io.CompleteFunction;
	import ErrorFunction = alm.io.ErrorFunction;

	export class TextureFileHandler implements IFileHandler {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getType():string {
			return TextureFileHandler.TYPE;
		}

		public load(url:string, onComplete:CompleteFunction, onError:ErrorFunction):void {
			const loader:THREE.TextureLoader = new THREE.TextureLoader();
			loader.crossOrigin = 'anonymous';
			loader.load(url, (texture:THREE.Texture):void => {
				onComplete(texture);
			}, (event:ProgressEvent):void => {
			}, (event:ErrorEvent):void => {
				onError({ errorEvent: event });
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static TYPE:string = 'THREE.Texture';
	}
}
